import React from 'react';
import { PlayCircle } from 'lucide-react';

/* "▶ How to use <feature>" pill — same look as the "How to use Zap" button on
   the Zap automations page. */
export default function GuideButton({ onClick, feature }: { onClick: () => void; feature: string }) {
    return (
        <button
            type="button"
            onClick={onClick}
            className="inline-flex items-center gap-2 text-[14px] font-medium text-[#9C52A2] border border-[#e8d3ec] bg-[#faf5fb] hover:bg-[#f3e6f5] rounded-full px-4 py-2 transition"
            style={{ cursor: 'pointer', whiteSpace: 'nowrap' }}
        >
            <PlayCircle className="w-4 h-4" /> How to use {feature}
        </button>
    );
}
